import React from 'react';
import { useNavigate } from 'react-router';

export default function TestLanding() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-900 via-emerald-800 to-teal-900 text-white flex items-center justify-center p-8">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-6xl font-black mb-6">
          🎉 Landing Page is Working! 🎉
        </h1>
        <p className="text-2xl mb-8">
          This is a test page to confirm the landing page is loading properly.
        </p>
        
        <div className="grid gap-4 mb-8">
          <button
            onClick={() => navigate('/powerful')}
            className="px-8 py-4 bg-green-500 hover:bg-green-600 rounded-xl font-bold text-xl"
          >
            Go to Powerful Landing Page
          </button>
          <button
            onClick={() => navigate('/front')}
            className="px-8 py-4 bg-blue-500 hover:bg-blue-600 rounded-xl font-bold text-xl"
          >
            Go to Front Advert
          </button>
          <button
            onClick={() => navigate('/app')}
            className="px-8 py-4 bg-purple-500 hover:bg-purple-600 rounded-xl font-bold text-xl"
          >
            Go to Main App
          </button>
        </div>

        <div className="bg-white/10 rounded-2xl p-6 backdrop-blur-xl">
          <h2 className="text-2xl font-bold mb-4">Available Routes:</h2>
          <ul className="text-left space-y-2">
            <li>✅ / - Test Landing (this page)</li>
            <li>✅ /powerful - Powerful Landing Page</li>
            <li>✅ /front - Front Advert</li>
            <li>✅ /app - Main Application</li>
            <li>✅ /landing - Full Landing Page</li>
            <li>✅ /promo - Promo Template</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
